import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsWooCommerce() {
  return (
    <IntegrationDocTemplate
      title="WooCommerce"
      category="Platform"
      status="beta"
      summary="WooCommerce REST API + webhooks. Consumer key/secret auth. Works with self-hosted WordPress + WooCommerce. Recommended for stores under 50K orders/month; larger volume → BigCommerce or Shopify Plus."
      prerequisites={[
        'WordPress + WooCommerce 7.x+ installed.',
        'REST API enabled at WooCommerce → Settings → Advanced → REST API.',
        'Consumer key + Consumer secret (read/write scope).',
        'Site reachable via HTTPS (Cloudflare or hosting SSL).',
      ]}
      connectSteps={[
        'Text us "WooCommerce" with your phone number.',
        'Paste your store URL + Consumer key/secret.',
        'First sync: products, orders, customers (chunked to avoid PHP timeouts).',
        'Webhook auto-registration for orders.create/update + product/inventory events.',
      ]}
      syncedData={[
        { type: 'Products', detail: 'Simple + variable products, attributes, variations, stock' },
        { type: 'Orders', detail: 'List/get with line items, shipping, billing, status transitions' },
        { type: 'Inventory', detail: 'Per-product stock_quantity + per-variation' },
        { type: 'Customers', detail: 'Customer records with billing/shipping addresses' },
      ]}
      agents={[
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
      ]}
      troubleshooting={[
        { question: 'Slow sync on large catalogs', answer: 'WooCommerce REST API is slow at >10K products due to PHP execution limits. We chunk requests and use the WP-Cron offload. Expect ~1 hour for full first sync of 50K products.' },
        { question: 'Webhooks not firing', answer: 'WooCommerce requires WP-Cron or a real cron job. Disable Cloudflare bot protection on your /wc-api endpoint, or use the manual sync via /dashboard/inventory.' },
      ]}
      supportLink="/contact"
    />
  );
}
